'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDeviceHub = function MdDeviceHub(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 26.6h6.6v8.4h-8.4v-5.1l-6.6-7-6.6 7v5.1h-8.4v-8.4h6.6l6.8-6.6v-5.3c-2-0.7-3.4-2.5-3.4-4.7 0-2.7 2.3-5 5-5s5 2.3 5 5c0 2.2-1.4 4-3.4 4.7v5.3z' })
        )
    );
};

exports.default = MdDeviceHub;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/device-hub.js
// module id = 2991
// module chunks = 0